<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <!-- 別SPAに遷移する場合にはhrefで遷移先を指定(preventDefaultで止める必要があるため) -->
          <ng-container *ngIf="isFromServicingMybooking(); else checkinFlow">
            <a
              id="checkin-select-sub-header-back-1"
              class="l-top-navi__back-link"
              [href]="backUrl"
              (click)="onClickBackButton($event)"
            >
              <span
                class="u-visually-hidden"
                innerHTML="{{ 'm_static_message-reader.goBackToPreviousPage' | staticMsg }}"
              ></span
            ></a>
          </ng-container>
          <!-- 同一SPA内の遷移であればrouterLinkで遷移先を指定(そのまま遷移して問題ないので) -->
          <ng-template #checkinFlow>
            <a
              id="checkin-select-sub-header-back-2"
              class="l-top-navi__back-link"
              [routerLink]="backUrl"
              (click)="updatePreviousPageIdentifier()"
            >
              <span
                class="u-visually-hidden"
                innerHTML="{{ 'm_static_message-reader.goBackToPreviousPage' | staticMsg }}"
              ></span
            ></a>
          </ng-template>
        </div>
        <div class="l-top-navi__heading-area">
          <h1
            class="l-top-navi__heading-text"
            innerHTML="{{ 'm_static_message-heading.onlineCheckInSelect' | staticMsg }}"
          ></h1>
        </div>
      </div>
    </div>
  </div>
</div>
